export const loadingSelector = state => ({
  loading: // state.auth.loading ||
    // state.channels.loading ||
    // state.clips.loading ||
    state.s3.loading // ||
    // state.users.loading ||
    // state.groups.loading
});
